<template>
  <div class="knd-header bg-secondary knd-paragraph">
    <div class="knd-wrapper-xs bg-primary">
      <div class="header-image">
        <img src='@/assets/Tool-illustratie.jpg' />
      </div>

      <div class="header-content knd-wrapper-text knd-paragraph">
        <h2 class="header-title">{{ title }}</h2>

        <div class="header-intro">
          <p>
           {{intro}}
          </p>
        </div>

        <div class="knd-select-dropdown">
          <Dropdown
              :options="companies"
              :text="'kies je energiemaatschappij'"
              :dropdownFn='dropdownSelect' 
          />

        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { mapGetters, useStore } from 'vuex';
import {ref, computed} from 'vue';
import Dropdown from '@/components/dropdown/dropdown.vue';

const store = useStore()

const intro = computed(() => store.getters.intro);
const title = computed(() => store.getters.title);
const companies = computed(() => store.getters.companies);

const dropdownSelect = (e) => {
  store.dispatch('updateCompany', e)
}
</script>

<style style="scss" scoped> 
.knd-select-dropdown {
  --knd-dropdown-color: #FF5362;
  --knd-dropdown-highlight-text: #FF5362;
  --knd-dropdown-highlight: #F8F5F2;
  --knd-dropdown-bg: var(--off-white);
}

</style>